import { render, staticRenderFns } from "./ChangeTable.vue?vue&type=template&id=6a37a410&scoped=true&"
import script from "./ChangeTable.vue?vue&type=script&lang=js&"
export * from "./ChangeTable.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTable.vue?vue&type=style&index=0&id=6a37a410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37a410",
  null
  
)

export default component.exports